// Replace Expivi "Add to Cart" with "Request Quote" button
document.addEventListener('DOMContentLoaded', function () {
  function replaceExpiviButton() {
    const originalBtn   = document.querySelector('.btn.expivi-add-to-cart');
    const bottomContent = document.querySelector('.bottom-content');

    if (!originalBtn || !bottomContent) {
      // Wait until Expivi renders the button
      setTimeout(replaceExpiviButton, 300);
      return;
    }

    // Create the new button
    const rfqBtn = document.createElement('button');
    rfqBtn.type = 'button';
    rfqBtn.className = 'btn expivi-rfq';
    rfqBtn.textContent = 'Request Quote';

    // Replace the original Add to Cart button
    originalBtn.replaceWith(rfqBtn);

    console.log('✅ Replaced Expivi "Add to Cart" with "Request Quote" button');
  }

  replaceExpiviButton();
});


// ===============================================================
//  HIDDEN ATTRIBUTES (Ticket: hide internal/technical fields in
//  the Request Quote summary — both the modal preview AND the
//  Make.com email). Case-sensitive match on attribute_name.
//  These are control/helper attributes the customer must not see.
// ===============================================================
const SKIP_ATTRIBUTE_NAMES = new Set([
  // Redundant duplicate input mirrors (driven by the *-input-base sync)
  'Front Number input 01',
  'Front Number input 02',
  'Player name input 01',
  'Player name input 02',
  'Back Number input 01',
  'Back Number input 02',
  'Team logo input 01',
  'Team logo input 02',
  'Pants front number input 01',
  'Pants front number input 02',
  'Pants back number input 01',
  'Pants back number input 02',
  // Internal "Element selector" toggles (drive visibility, not user choices)
  'Jersey Pinstripe Element selector',
  'Jersey Team Logo Element selector',
  'Jersey Trim1 Element selector',
  'Jersey Trim2 Element selector',
  'NeckPiping 01 Element selector',
  'NeckPiping 02 Element selector',
  'NeckPiping 03 Element selector',
  'NeckPiping 04 Element selector',
  'NeckPiping 05 Element selector',
  'SleevePiping 01 Element selector',
  'SleevePiping 02 Element selector',
  'SleevePiping 03 Element selector',
  'Jersey Front number element selector',
  'Jersey Front number trim 1 element selector',
  'Jersey Front number trim 2 element selector',
  'Jersey Back number element selector',
  'Jersey Back number trim 1 element selector',
  'Jersey Back number trim 2 element selector',
  'Player name back element selector',
  'Player name trim 1 element selector',
  'Player name trim 2 element selector',
  'Left sleeve logo element selector',
  'Right sleeve logo element selector',
  'Back of neck logo element selector',
  'Pants pinstripes element selector',
  'PantPiping 01 element selector',
  'PantPiping 02 element selector',
  'PantPiping 03 element selector',
  'Pant number base element selector',
  'Pant number trim 01 selector',
  'Pant number trim 02 selector',
  'Add a logo to the pants element selector',
  // Standalone font summary lines (font is already shown inline as @font: in the value)
  'Player name font',
  'Back number font',
  'Front number font',
  'Select team logo font',
  'Pant number font',
  // Misc control attributes
  'CollarPiping',
  'Pants_DynamicPattern',
  'Toggle camera',
  'Collar type',
  'Camera positions'
]);

function isSkippedAttribute(name) {
  return !name || SKIP_ATTRIBUTE_NAMES.has(name);
}

// ===============================================================
//  CONDITIONAL HIDING — only keep attributes relevant to the
//  chosen options. The configurator returns EVERY attribute in a
//  flat, ordered list (incl. ones made irrelevant by a previous
//  answer), so relevance is resolved POSITIONALLY:
//   - a "count" controller (number of trim colors / piping style)
//     limits how many of the repeated color group right after it
//     are kept — this also collapses duplicate color groups.
//   - a "...?: No" controller hides the specific children that
//     follow it.
// ===============================================================

// "None" -> 0, "1"/"2" -> n, "2 Colors" -> 2, "1/2\" thickness" -> null (keep all)
function quoteKeepCount(value) {
  const v = (value || '').trim();
  if (/^none$/i.test(v)) return 0;
  /* The piping controllers say "No neck piping" / "No sleeve piping" rather
     than "None". Without this they fell through to null — "keep all" — so a
     jersey ordered with NO piping still listed "Neck piping color 1/2/3" on the
     quote, which is exactly the ambiguity production complained about.
     Anchored to a word boundary so "None" (already handled above) and any real
     option that merely starts with "no" are unaffected. */
  if (/^no(\s|$)/i.test(v)) return 0;
  const colors = /^(\d+)\s*colou?rs?$/i.exec(v);
  if (colors) return parseInt(colors[1], 10);
  if (/^\d+$/.test(v)) return parseInt(v, 10);
  return null;
}

// count controller (name prefix) -> the repeated group that follows it
var QUOTE_GROUP_LIMITERS = [
  { trigger: /^Select number of trim colors for /i, group: /^Select Trim color \d+$/i },
  { trigger: /^Select Neck piping style$/i,         group: /^Neck piping color \d+$/i },
  { trigger: /^Select Sleeve piping style$/i,       group: /^Sleeve piping color \d+$/i },
  { trigger: /^Select pant piping style$/i,         group: /^Pant piping color \d+$/i }
];

/* PIPING WIDTH (Asana "PRF", point 7a).
   Production wanted the cut width stated next to the piping option so there is
   no ambiguity about which one was ordered:
       1 Color = 1/8"    2 Colors = 3/8"    3 Colors = 1/2"
   The client gave that table once, generically, while the catalogue has THREE
   piping zones (Neck 266387, Sleeve 266312, Pant). It is applied to all three
   because that is what they wrote — if a zone turns out to use different
   widths, change the table here and nothing else needs touching.
   NOT printed on the print-ready file itself: that artwork comes from an Expivi
   SVG template we do not own. It goes where we do control the output — the
   quote email, the confirmation modal and the branded quote sheet. */
var XPV_PIPING_STYLE  = /^Select\s+(.+?)\s+piping style$/i;
var XPV_PIPING_WIDTHS = { 1: '1/8"', 2: '3/8"', 3: '1/2"' };

// "2 Colors" -> '3/8"'. null for "No neck piping" and for anything unmapped, so
// an unexpected value prints as-is instead of carrying a wrong measurement.
function xpvPipingWidth(valueName) {
  var n = quoteKeepCount(valueName);
  return (n && XPV_PIPING_WIDTHS[n]) || null;
}

// "Select pant piping style" -> "Pant"
function xpvPipingZone(attrName) {
  var m = XPV_PIPING_STYLE.exec(attrName || '');
  if (!m) return null;
  var z = m[1].trim();
  return z.charAt(0).toUpperCase() + z.slice(1).toLowerCase();
}

// The value as it should read on a quote: the selection, plus its width when
// the attribute is a piping controller.
function xpvQuoteValue(attr) {
  var val = (attr && attr.attribute_value_name) || '';
  if (!XPV_PIPING_STYLE.test((attr && attr.attribute_name) || '')) return val;
  var w = xpvPipingWidth(val);
  return w ? val + ' (' + w + ')' : val;
}

// "...?: No" controller -> exact child names hidden when its value is "No"
// (trailing "Select Trim color #" are handled by the count limiter above)
var QUOTE_NO_HIDES = {
  'Add Pinstripes to jersey?': ['Jersey pinstripe color'],
  'Add Pinstripes to pants':   ['Pants pinstripe color'],
  'Add a logo to the pants':   ['Select logo location'],
  /* The jersey equivalents of the pant-number entry below, which were never
     added. A jersey ordered WITHOUT a number still carried the base colour, the
     trim count and the "…input Base" line — the last one complete with a stale
     value from whatever was typed before the toggle was switched off, e.g.
     "Front Number input Base: 24" under "Include Front Number: No".
     The "…input Base" lines are NOT hidden outright: when the number IS ordered
     they are the only place the entered value and its @size/@font travel (which
     is why the standalone font attributes are skipped, see SKIP_ATTRIBUTE_NAMES). */
  'Include Front Number': [
    'Select front number base color',
    'Select number of trim colors for front number',
    'Front Number input Base'
  ],
  'Include Rear Number': [
    'Select back number base color',
    'Select number of trim colors for back number',
    'Back Number input Base'
  ],
  'Add player name to back': [
    'Select player name base color',
    'Select number of trim colors for player name',
    'Player name input Base'
  ],
  /* The single pant trim line became two when the catalogue split the control
     per position, and the old name stopped matching — so with the pant number
     switched OFF both trim lines were reaching the quote. */
  'Add a number to the pants': [
    'Select number location',
    'Pants front number input Base',
    'Pants back number input Base',
    'Select pant number base color',
    'Select number of trim colors for front of pant',
    'Select number of trim colors for back of pant'
  ]
};

function filterAttributesForQuote(list) {
  if (!Array.isArray(list)) return [];
  var out = [];
  var group = null;            // active keep-first-N run: { regex, remaining }
  var hideNames = new Set();   // exact child names flagged by a "...: No" parent

  for (var i = 0; i < list.length; i++) {
    var attr = list[i];
    var name = attr && attr.attribute_name;
    var val  = attr && attr.attribute_value_name;
    if (!name || !val) continue;          // drop blank/null
    if (isSkippedAttribute(name)) continue; // static technical fields

    // Inside an active color/trim run: keep the first N, drop the rest.
    if (group) {
      if (group.regex.test(name)) {
        if (group.remaining > 0) { group.remaining--; out.push(attr); }
        continue;
      }
      group = null; // run ended on first non-member
    }

    // Count controller: arm the limiter for the following group either way,
    // and keep the controller line itself unless a parent "No" hid it.
    var limiter = null;
    for (var j = 0; j < QUOTE_GROUP_LIMITERS.length; j++) {
      if (QUOTE_GROUP_LIMITERS[j].trigger.test(name)) { limiter = QUOTE_GROUP_LIMITERS[j]; break; }
    }
    if (limiter) {
      var k = quoteKeepCount(val);
      if (k !== null) group = { regex: limiter.group, remaining: k };
      if (hideNames.has(name)) hideNames.delete(name);
      else out.push(attr);
      continue;
    }

    // Child hidden by a preceding "...: No" parent.
    if (hideNames.has(name)) { hideNames.delete(name); continue; }

    // "...: No" controller: keep its line, and arm hiding of its children.
    if (Object.prototype.hasOwnProperty.call(QUOTE_NO_HIDES, name)) {
      out.push(attr);
      if (/^no$/i.test(val.trim())) {
        QUOTE_NO_HIDES[name].forEach(function (n) { hideNames.add(n); });
      }
      continue;
    }

    out.push(attr);
  }
  return out;
}

// ===============================
//  SAVE MODAL + EMAIL VALIDATION
// ===============================
function initExpiviSaveModal() {
  // RFQ trigger button
  const saveBtn       = document.querySelector('.btn.expivi-rfq');

  const modal         = document.getElementById('save-modal-wrapper');
  const attributeList = document.getElementById('saveModalAttributes');
  const cancelBtn     = document.getElementById('cancelSaveModal');
  const closeBtn      = document.getElementById('closeSaveModal');
  const confirmBtn    = document.getElementById('confirmSaveModal');

  // Inputs
  const nameInput = document.getElementById('saveModalName');
  const orgInput  = document.getElementById('saveModalOrganization');
  const phoneInput= document.getElementById('saveModalPhone');
  const emailInput= document.getElementById('saveModalEmail');
  const hiddenUrl = document.getElementById('saveModalPageUrl');
  // P9 qualifying questions
  const roleInput     = document.getElementById('saveModalRole');
  const packageInput  = document.getElementById('saveModalPackage');
  const playersInput  = document.getElementById('saveModalPlayers');
  const timelineInput = document.getElementById('saveModalTimeline');

  // ✅ Do NOT require thumbnails to exist to initialize
  if (!saveBtn || !modal || !attributeList || !emailInput || !nameInput || !confirmBtn) {
    setTimeout(initExpiviSaveModal, 300);
    return;
  }

  // Helpers
  const EMAIL_RE = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
  const isValidEmail = (email) => EMAIL_RE.test(email.trim());

  emailInput.setAttribute('type', 'email');
  emailInput.setAttribute('pattern', EMAIL_RE.source);

  // Page 5: all fields mandatory — mark them required + show an asterisk on the
  // label so it's visually clear (validation itself is enforced in confirmBtn).
  function markRequired(input) {
    if (!input) return;
    input.required = true;
    input.setAttribute('aria-required', 'true');
    var lbl = input.id ? document.querySelector('label[for="' + input.id + '"]') : null;
    if (!lbl) { var prev = input.previousElementSibling; if (prev && prev.tagName === 'LABEL') lbl = prev; }
    if (lbl && lbl.querySelector('.xpv-req') === null && !/\*/.test(lbl.textContent)) {
      var star = document.createElement('span');
      star.className = 'xpv-req';
      star.setAttribute('aria-hidden', 'true');
      star.textContent = ' *';
      lbl.appendChild(star);
    }
  }
  [nameInput, orgInput, phoneInput, emailInput,
   roleInput, packageInput, playersInput, timelineInput].forEach(markRequired);

  function resetConfirmButton() {
    confirmBtn.disabled = false;
    confirmBtn.innerHTML = 'Send quote request';
  }

  function closeModal() {
    modal.classList.remove('show');
    modal.classList.add('hide');
    setTimeout(() => {
      modal.style.display = 'none';
      modal.classList.remove('hide');
      resetConfirmButton();
    }, 300);
  }

  modal.addEventListener('click', (e) => {
    if (e.target === modal) closeModal();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal.style.display === 'flex') closeModal();
  });

  // -----------------------------
  //  SCREENSHOTS + CONFIG CAPTURE
  // -----------------------------
  window.handleMoonaSaveClick = async function () {
    console.log('🧠 handleMoonaSaveClick triggered');

    if (typeof expivi?.saveConfiguration !== 'function') {
      alert('Expivi is not ready yet.');
      return;
    }

    try {
      const delay = (ms) => new Promise((r) => setTimeout(r, ms));

      // Save configuration
      const configJson = await expivi.saveConfiguration(0, 0);

      // Screenshots
      const frontScreenshot = await expivi.getScreenshot(720, 720, 'FIT_OBJECT_FRONT', 'image/jpeg');
      await delay(500);
      const backScreenshot  = await expivi.getScreenshot(720, 720, 'FIT_OBJECT_BACK',  'image/jpeg');

      // Clean base64
      const cleanBase64 = (s) => (s || '').replace(/^data:image\/jpeg;base64,/, '').trim();
      const frontBase64 = cleanBase64(frontScreenshot);
      const backBase64  = cleanBase64(backScreenshot);

      // Add preview-only thumbnails
      configJson.thumbnail_front = frontScreenshot;
      configJson.thumbnail_back  = backScreenshot;
      configJson.thumbnail       = frontScreenshot;

      // Keep for submit
      window._latestConfigJson  = configJson;
      window._latestScreenshots = { front: frontBase64, back: backBase64 };

      // Clean URL for payload
      const url = new URL(window.location.href);
      url.searchParams.delete('configuration');
      if (hiddenUrl) hiddenUrl.value = url.toString();

      // Show modal
      window.showSaveModal(configJson);
    } catch (err) {
      console.error('❌ Error saving configuration or capturing screenshots:', err);
      alert('An error occurred while generating screenshots.');
    }
  };

  // Bind actions
  saveBtn.addEventListener('click', window.handleMoonaSaveClick);
  cancelBtn.onclick = closeModal;
  closeBtn.onclick  = closeModal;

  // -----------------------------
  //  P10: "quote sent" confirmation popup
  // -----------------------------
  function showQuoteSentPopup() {
    if (document.getElementById('xpv-quote-sent-overlay')) return;
    const overlay = document.createElement('div');
    overlay.id = 'xpv-quote-sent-overlay';
    overlay.innerHTML =
      '<div class="xpv-quote-sent" role="dialog" aria-modal="true" aria-labelledby="xpv-quote-sent-title">' +
        '<button class="xpv-quote-sent__close" type="button" aria-label="Close">&times;</button>' +
        '<h3 id="xpv-quote-sent-title" class="xpv-quote-sent__title">Your quote request has been sent to our team!</h3>' +
        '<p class="xpv-quote-sent__text">Please check your email for next steps. ' +
        'If you don’t see it shortly, be sure to check your spam or junk folder.</p>' +
        '<button class="xpv-quote-sent__ok" type="button">Close</button>' +
      '</div>';
    document.body.appendChild(overlay);
    const remove = () => overlay.remove();
    overlay.querySelector('.xpv-quote-sent__close').addEventListener('click', remove);
    overlay.querySelector('.xpv-quote-sent__ok').addEventListener('click', remove);
    overlay.addEventListener('click', (e) => { if (e.target === overlay) remove(); });
  }

  // -----------------------------
  //  SUBMIT TO MAKE.COM
  // -----------------------------
  confirmBtn.onclick = async () => {
    const fullName    = (nameInput.value || '').trim();
    const organization= (orgInput?.value || '').trim();
    const phone       = (phoneInput?.value || '').trim();
    const email       = (emailInput.value || '').trim();
    // P9 qualifying questions
    const role        = (roleInput?.value || '').trim();
    const packageType = (packageInput?.value || '').trim();
    const players     = (playersInput?.value || '').trim();
    const timeline    = (timelineInput?.value || '').trim();
    const configJson  = window._latestConfigJson;

    // All fields are mandatory (Page 5 feedback).
    if (!fullName) { alert('Please enter your full name.'); nameInput.focus(); return; }
    if (orgInput && !organization) { alert('Please enter your organization.'); orgInput.focus(); return; }
    if (phoneInput && !phone) { alert('Please enter your phone number.'); phoneInput.focus(); return; }
    if (!email)    { alert('Please enter your email address.'); emailInput.focus(); return; }
    if (!isValidEmail(email)) { alert('Please enter a valid email address.'); emailInput.focus(); return; }
    // P9 qualifying questions — mandatory
    if (roleInput && !role) { alert('Please select your role.'); roleInput.focus(); return; }
    if (packageInput && !packageType) { alert('Please select a package type.'); packageInput.focus(); return; }
    if (playersInput && !players) { alert('Please select the number of players.'); playersInput.focus(); return; }
    if (timelineInput && !timeline) { alert('Please select how quickly you need these uniforms.'); timelineInput.focus(); return; }
    if (!configJson) { alert('Configuration data is missing.'); return; }

    // Disable button & show spinner
    confirmBtn.disabled = true;
    confirmBtn.innerHTML = `
      <span class="spinner" style="
        border: 2px solid #fff;
        border-top: 2px solid transparent;
        border-radius: 50%;
        width: 14px;
        height: 14px;
        display: inline-block;
        margin-right: 8px;
        animation: spin 0.6s linear infinite;
        vertical-align: middle;"></span> Preparing your quote...`;

    // Safe copy of configuration
    const configCopy = JSON.parse(JSON.stringify(configJson));
    const { front, back } = window._latestScreenshots || {};

    // Build HTML summary of attributes & selected options
    let htmlLines = '<div class="configuration-line-items"><b>Configuration details</b><br><br>';
    if (Array.isArray(configCopy.configured_products)) {
      configCopy.configured_products.forEach(prod => {
        const attrs = Array.isArray(prod?.configuration?.attributes)
          ? prod.configuration.attributes
          : Array.isArray(prod?.attributes) ? prod.attributes : [];
        filterAttributesForQuote(attrs).forEach(attr => {
          htmlLines += `<b>${attr.attribute_name}:</b> ${xpvQuoteValue(attr)}<br>`;
        });
      });
    }
    htmlLines += '</div>';

    // Collect all unique print_ready_file_id values (across all configured products)
    const prfIds = getPrintReadyFileIds(configCopy);

    // Remove preview-only images before sending
    delete configCopy.thumbnail_front;
    delete configCopy.thumbnail_back;
    delete configCopy.thumbnail;

    // Branded quote sheet (P12): Luccini header + colour swatches + the PRF
    // render. Built before the webhook call so it can travel in the same
    // payload. Returns null on any failure — the quote is never blocked by it.
    const brandedPdf = await xpvBuildQuoteSheet(configJson, {
      name: fullName, organization, email, phone
    });

    // Payload to Make.com
    const payload = {
      name: fullName,
      organization,
      phone,
      email,
      // P9 qualifying questions
      role,
      package_type: packageType,
      players_count: players,
      timeline,
      page_url: hiddenUrl ? hiddenUrl.value : window.location.href,
      configuration: configCopy,
      screenshot_front: front || '',
      screenshot_back:  back || '',
      'configuration-line-items': htmlLines,
      print_ready_file_ids: prfIds, // ← NEW
      // Base64 PDF (no data: prefix) — Make attaches it to the internal email.
      // Empty string when the sheet could not be built, so the pill always exists.
      branded_pdf_base64: brandedPdf || '',
      branded_pdf_filename: 'Luccini-Quote-' + (fullName || 'customer').replace(/[^\w\-]+/g, '-') + '.pdf',
      // Internal test flag — see XPV_INTERNAL_EMAIL. Make uses it to keep test
      // submissions away from the Luccini inboxes.
      is_internal_test: XPV_INTERNAL_EMAIL.test(email)
    };

    if (payload.is_internal_test) {
      console.log('🧪 Internal test submission (@expivi.com) — Make should keep this out of the Luccini inboxes.');
    }

    const postToMake = () => {
      fetch('https://hook.eu2.make.com/vp1ijmu3jb8hu9wer4aiemvvf5oqd80c', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(response => {
          console.log('📤 Sent to Make.com:', response.status);
          setTimeout(() => {
            // P10: show a confirmation popup instead of just changing the button label.
            showQuoteSentPopup();
            closeModal();
          }, 800);
        })
        .catch(error => {
          console.error('❌ Error sending to Make.com:', error);
          resetConfirmButton();
        });
    };

    // ?xpv_pdf_preview=1 → inspect the sheet and stop here. Nothing reaches
    // Make, so the live scenario and its emails are untouched.
    if (xpvPreviewMode()) {
      console.log('👁️ Preview mode — quote NOT sent. Payload was:', payload);
      resetConfirmButton();
      xpvShowSheetPreview(postToMake);
      return;
    }

    postToMake();
  };

  // -----------------------------
  //  RENDER MODAL PREVIEW
  // -----------------------------
  window.showSaveModal = function (configJson) {
    const attributes = Array.isArray(configJson.attributes) ? configJson.attributes : [];

    const imgFront = document.getElementById('saveModalThumbnailFront');
    const imgBack  = document.getElementById('saveModalThumbnailBack');

    if (imgFront) {
      if (configJson.thumbnail_front) { imgFront.style.display = 'block'; imgFront.src = configJson.thumbnail_front; }
      else { imgFront.style.display = 'none'; }
    }

    if (imgBack) {
      if (configJson.thumbnail_back) { imgBack.style.display = 'block'; imgBack.src = configJson.thumbnail_back; }
      else { imgBack.style.display = 'none'; }
    }

    attributeList.innerHTML = filterAttributesForQuote(attributes)
      .map(attr => `<li><strong>${attr.attribute_name}:</strong> ${xpvQuoteValue(attr)}</li>`)
      .join('');

    modal.classList.add('show');
    modal.style.display = 'flex';
    resetConfirmButton();
  };
}


// ==================================
//  UTIL: COLLECT UNIQUE PRF ID LIST
// ==================================
function collectAllAttributes(conf) {
  const out = [];
  const cps = Array.isArray(conf?.configured_products) ? conf.configured_products : [];
  cps.forEach(cp => {
    if (Array.isArray(cp.attributes)) out.push(...cp.attributes);
    if (Array.isArray(cp?.configuration?.attributes)) out.push(...cp.configuration.attributes);
  });
  return out;
}

function getPrintReadyFileIds(conf) {
  const ids = new Set();
  collectAllAttributes(conf).forEach(attr => {
    const id = attr?.attribute_value?.print_ready_file_id;
    if (id) ids.add(id);
  });
  return [...ids];
}


/* ============================================================================
   BRANDED QUOTE PDF (P12) — Luccini header + colour swatches + PRF
   ----------------------------------------------------------------------------
   Goal: the "Sokkies look" — a branded sheet with the Luccini logo and the
   selected colours as swatch bubbles in the header, and the actual PRINT-READY
   FILE render in the centre.

   Why we build it here and not in Make / Expivi:
     • Expivi's own branded-PDF route is `POST /api/catalogue/{id}/export-
       configuration`, which renders a Twig template living in the tenant's
       Expivi webshop theme. Luccini sells on Shopify — we have no such theme,
       and deploying one is a platform-side job. So step 5 of the Sokkies
       pipeline is unavailable to us.
     • Steps 1-4 of that pipeline are plain API calls and DO work from here.
       They are what produces the PRF as a PNG:
         1. saveConfiguration                        (already done on save)
         2. POST /api/configured_product/bundle      -> configured_product_id
         3. POST /api/svg/conversion/request/png     -> conversion hash
         4. GET  /api/print-ready-service/{hash}     -> poll -> files[0] = PNG
     • So we run 1-4, then compose the page ourselves (canvas -> jsPDF) and ship
       it in the webhook payload we already control. No third-party PDF service.

   NOTE: this does NOT modify Expivi's print-ready file. It is an additional
   branded document attached to the internal Luccini quote email. Putting the
   swatches INSIDE the PRF itself would have to be done by the config team in
   the print-ready SVG template.

   CORS: images on data.expivi.net cannot be drawn via <img crossOrigin> (the
   load fails), but `fetch` is allowed. We therefore fetch -> blob -> dataURL
   -> Image, which never taints the canvas.

   Failure policy: the quote email must ALWAYS go out. Every step is wrapped so
   that any error / timeout simply drops the attachment.
   ========================================================================= */

/* Resolve the theme asset folder from our own <script src> — never hardcode the
   CDN theme slot (t/7 today), it changes when the theme is republished. */
const XPV_ASSET_BASE = (() => {
  const src = [...document.querySelectorAll('script[src]')]
    .map(s => s.src).find(u => /expivi-custom\.js/.test(u));
  return src ? src.replace(/expivi-custom\.js.*$/, '') : '/cdn/shop/t/7/assets/';
})();

const XPV_BRAND = { dark: '#00262B', gold: '#CBA052', line: '#DDDDDD', text: '#1C1C1C' };

/* A quote submitted with an @expivi.com address is one of OURS, not a real
   customer. The payload carries `is_internal_test: true` for those, so Make can
   send the internal copy to whoever submitted instead of to Uniforms@ and the
   four Luccini CCs — i.e. we can test the whole live flow, attachment included,
   without a single email reaching BCLL. Real customers are unaffected: any
   other domain keeps the flag false and the flow behaves exactly as today. */
const XPV_INTERNAL_EMAIL = /@expivi\.com\s*$/i;

/* Load jsPDF from the theme assets on first use (keeps 360 KB off every page
   load). Served same-origin, so Shopify's CSP is satisfied. */
let _xpvJsPdfPromise = null;
function xpvLoadJsPdf() {
  if (window.jspdf && window.jspdf.jsPDF) return Promise.resolve(window.jspdf.jsPDF);
  if (_xpvJsPdfPromise) return _xpvJsPdfPromise;
  _xpvJsPdfPromise = new Promise((resolve, reject) => {
    const s = document.createElement('script');
    s.src = XPV_ASSET_BASE + 'jspdf.umd.min.js';
    s.onload = () => (window.jspdf && window.jspdf.jsPDF)
      ? resolve(window.jspdf.jsPDF)
      : reject(new Error('jsPDF loaded but global missing'));
    s.onerror = () => reject(new Error('jsPDF asset failed to load'));
    document.head.appendChild(s);
  });
  return _xpvJsPdfPromise;
}

/* fetch -> blob -> dataURL -> decoded Image (canvas-safe, see CORS note above) */
async function xpvLoadImage(url) {
  const r = await fetch(url);
  if (!r.ok) throw new Error('image fetch ' + r.status + ' for ' + url);
  const blob = await r.blob();
  const dataUrl = await new Promise((res, rej) => {
    const fr = new FileReader();
    fr.onload = () => res(fr.result);
    fr.onerror = rej;
    fr.readAsDataURL(blob);
  });
  const img = new Image();
  img.src = dataUrl;
  await img.decode();
  return img;
}

/* Attributes that actually describe the ordered garment.
   filterAttributesForQuote() is the approved Ticket-1 email filter; its scope
   was deliberately limited to the fields flagged in that ticket, so it does NOT
   drop the pant block when the customer chose "No pants". For this sheet that
   matters twice over: the pant colour attributes would contribute ghost swatch
   bubbles for a garment that isn't in the order, AND they carry the pants
   print_ready_file_id (7327), which then renders as a solid black square.
   We add that guard here rather than inside filterAttributesForQuote so the
   already-signed-off quote email keeps rendering exactly as approved.
   (The email has the same latent issue — worth raising separately.) */
function xpvRelevantAttributes(configJson) {
  const attrs = collectAllAttributes(configJson);
  const visible = (typeof filterAttributesForQuote === 'function')
    ? filterAttributesForQuote(attrs)
    : attrs;
  const noPants = visible.some(a =>
    /choose pant style/i.test(a.attribute_name || '') &&
    /^no pants$/i.test((a.attribute_value_name || '').trim()));
  if (!noPants) return visible;
  // Match on the attribute name AND on the bound svg_element: some pant layers
  // are named generically ("Luccini logo color" -> svg_element
  // "LucciniLogo_Pants"), so the name alone lets the pants PRF slip through.
  const isPants = (a) => /pant/i.test(a.attribute_name || '') ||
    /pants/i.test((a.attribute_value && a.attribute_value.svg_element) || '');
  return visible.filter(a => !isPants(a));
}

/* The piping selection per zone, with the width production has to cut it at.
   Built from xpvRelevantAttributes() like everything else on the sheet, so a
   pants-less order simply has no Pant row. A zone with no piping IS listed —
   stating "No neck piping" explicitly is the point of the request, since an
   absent line reads as "nobody filled it in". */
function xpvGetPiping(configJson) {
  const rows = [];
  const seen = new Set();
  xpvRelevantAttributes(configJson).forEach(a => {
    const zone = xpvPipingZone(a && a.attribute_name);
    if (!zone || seen.has(zone)) return;
    seen.add(zone);
    const value = ((a && a.attribute_value_name) || '').trim();
    rows.push({ zone, value, width: xpvPipingWidth(value) });
  });
  return rows;
}

/* Selected colours -> swatch bubbles, deduped by colour+label. */
function xpvGetSwatches(configJson) {
  const visible = xpvRelevantAttributes(configJson);
  const seen = new Set();
  const out = [];
  visible.forEach(a => {
    const v = a && a.attribute_value;
    const hex = v && typeof v.value === 'string' ? v.value.trim() : '';
    if (!/^#[0-9a-f]{3,8}$/i.test(hex)) return;              // colour values only
    const label = (v.name || a.attribute_value_name || '').trim();
    const key = hex.toLowerCase() + '|' + label.toLowerCase();
    if (seen.has(key)) return;                                // same colour reused
    seen.add(key);
    out.push({ hex, label: label || hex.toUpperCase() });
  });
  return out;
}

/* Steps 2-4: turn the saved configuration into PNGs of the print-ready files.
   A Luccini quote has MORE THAN ONE prf id (e.g. 7035 jersey + 7327 pants), so
   we render every one of them, not just the first. */
async function xpvGetPrfPngUrls(configJson, { timeoutMs = 45000 } = {}) {
  const token = window.expivi && window.expivi.apiToken;
  if (!token) throw new Error('no apiToken');
  const auth = { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token };

  // Derive the prf ids from the RELEVANT attributes only — see
  // xpvRelevantAttributes(). Using the raw configuration here would pull in the
  // pants print-ready file even when the customer ordered no pants.
  //
  // Each id is named after the garment it belongs to, because neither Expivi's
  // internal file name nor the bare id means anything to the person reading the
  // quote. An attribute belongs to the pants if its NAME says so or if the layer
  // it binds does ("Luccini logo colour" binds LucciniLogo_Pants) — the same
  // test xpvRelevantAttributes() uses, so the two never disagree. One pant
  // reference is enough to name the file, hence pants wins over an earlier
  // jersey guess.
  const prfLabels = new Map();
  xpvRelevantAttributes(configJson).forEach(a => {
    const v = a && a.attribute_value;
    const id = v && v.print_ready_file_id;
    if (!id) return;
    const isPants = /pant/i.test(a.attribute_name || '') ||
      /pants/i.test((v && v.svg_element) || '');
    if (!prfLabels.has(id) || isPants) {
      prfLabels.set(id, isPants ? 'Pant print ready file' : 'Jersey print ready file');
    }
  });
  const prfIds = [...prfLabels.keys()];
  if (!prfIds.length) throw new Error('no print_ready_file_id in configuration');

  // Step 2 — persist the bundle, get the configured_product_id
  const bundleRes = await fetch('https://expivi.net/api/configured_product/bundle', {
    method: 'POST',
    headers: auth,
    body: JSON.stringify({
      bundle_uuid: configJson.bundle_uuid,
      configured_products: configJson.configured_products
    })
  });
  if (!bundleRes.ok) throw new Error('bundle ' + bundleRes.status);
  const cpId = Object.values(await bundleRes.json())[0];
  if (!cpId) throw new Error('bundle response missing configured_product_id');

  // Step 3 — ask for a PNG conversion of every prf id (the .pdf variant is what
  // Make already requests for the download link; we need a raster we can draw).
  // Fire them all first, then poll, so the renders run in parallel server-side.
  const hashes = [];
  for (const prfId of prfIds) {
    const convRes = await fetch('https://expivi.net/api/svg/conversion/request/png', {
      method: 'POST',
      headers: auth,
      body: JSON.stringify({ configured_product_id: cpId, print_ready_file_id: prfId })
    });
    if (!convRes.ok) { console.warn('⚠️ conversion failed for prf', prfId, convRes.status); continue; }
    const j = await convRes.json();
    if (j && j.hash) {
      hashes.push({ prfId, hash: j.hash, label: prfLabels.get(prfId) || ('Print ready file #' + prfId) });
    }
  }
  if (!hashes.length) throw new Error('no conversion hash returned');

  // Step 4 — poll the public status endpoint until each render is complete
  const deadline = Date.now() + timeoutMs;
  const done = [];
  const pending = [...hashes];
  while (pending.length && Date.now() < deadline) {
    for (let i = pending.length - 1; i >= 0; i--) {
      const s = await fetch('https://expivi.net/api/print-ready-service/' + pending[i].hash, {
        headers: { Accept: 'application/json' }
      }).then(r => r.json()).catch(() => null);
      if (s && s.status === 'complete' && s.files && s.files.length) {
        // `hash` travels with the result so the sheet can print the link the
        // internal email already uses (expivi.net/print-ready-service?hash=…),
        // not only the picture. The file keeps living behind a real
        // configured_product (step 2), so the URL does not expire the way an
        // orphaned upload would.
        done.push({
          prfId: pending[i].prfId,
          hash:  pending[i].hash,
          label: pending[i].label,
          url:   s.files[0]
        });
        pending.splice(i, 1);
      }
    }
    if (pending.length) await new Promise(r => setTimeout(r, 1500));
  }
  if (!done.length) throw new Error('PRF conversion timed out');
  if (pending.length) console.warn('⚠️ some PRF renders timed out:', pending.map(p => p.prfId));
  return done;
}

/* Guard against a broken print-ready render.
   A healthy PRF PNG is mostly TRANSPARENT with the garment panels drawn on top
   (verified: the jersey render is ~75% transparent). The pants render currently
   comes back 100% opaque and 100% black regardless of the configuration —
   confirmed with pants both excluded AND set to "Pants long", so it is an
   Expivi-side template problem, not ours. Printing that would put a solid black
   square on the customer's quote, so we skip it and log loudly instead.
   Deliberately strict: a genuinely dark uniform still renders with transparency
   around the panels, so it will not trip this. */
function xpvIsBrokenPrfRender(img) {
  try {
    const c = document.createElement('canvas');
    c.width = img.naturalWidth; c.height = img.naturalHeight;
    const x = c.getContext('2d');
    x.drawImage(img, 0, 0);
    const d = x.getImageData(0, 0, c.width, c.height).data;
    let opaque = 0, transparent = 0, black = 0;
    for (let i = 0; i < d.length; i += 4 * 97) {          // sparse sample
      if (d[i + 3] === 0) { transparent++; continue; }
      opaque++;
      if ((d[i] + d[i + 1] + d[i + 2]) / 3 < 20) black++;
    }
    return transparent === 0 && opaque > 0 && black / opaque > 0.99;
  } catch (e) {
    return false;   // if we cannot inspect it, draw it
  }
}

/* Compose the sheet on a canvas, then wrap it in an A4 PDF.
   Drawing on a canvas (rather than emitting jsPDF primitives) keeps the whole
   layout in one familiar 2D API and guarantees the PDF looks exactly like what
   we can preview in the browser. Rendered at 2x for print sharpness. */
async function xpvBuildBrandedPdf({ swatches, piping, prfs, client }) {
  const jsPDF = await xpvLoadJsPdf();

  /* Supersampling factor. The page is one raster image, so this IS the sheet's
     resolution: a point is S pixels, making S=2 an effective 144 dpi. That is
     half of what print wants and it showed — text was legible but soft, which
     is what the client reported. S=4 puts the page at 288 dpi, near the 300 dpi
     print standard, and costs only encoding time. The embedded renders cannot
     gain detail they never had; the text, drawn here, does. */
  const S = 4;                       // supersampling factor
  const W = 595 * S, H = 842 * S;    // A4 portrait, points
  const M = 40 * S;                  // page margin
  const cv = document.createElement('canvas');
  cv.width = W; cv.height = H;
  const ctx = cv.getContext('2d');
  ctx.fillStyle = '#ffffff';
  ctx.fillRect(0, 0, W, H);

  const rule = (y) => {
    ctx.strokeStyle = XPV_BRAND.line;
    ctx.lineWidth = 1 * S;
    ctx.beginPath(); ctx.moveTo(M, y); ctx.lineTo(W - M, y); ctx.stroke();
  };

  let y = M;

  /* ---- HEADER: logo + title + client details ---- */
  /* Logo sources, in order:
       1. the store's own wordmark, already published in Shopify Files — wide
          format, correct branding, and nothing extra to upload;
       2. the LL monogram shipped as a theme asset, if someone prefers it;
       3. a drawn wordmark, so the sheet still ships if both are unreachable. */
  let logoBottom = y;
  const logoSources = [
    'https://liveluccini.com/cdn/shop/files/Luccini-Logo.png?width=542',
    XPV_ASSET_BASE + 'luccini-logo.webp'
  ];
  let logo = null;
  for (const src of logoSources) {
    try { logo = await xpvLoadImage(src); break; } catch (e) { /* try next */ }
  }
  let logoRight = M;
  if (logo) {
    // Cap BOTH dimensions: source 1 is a wide wordmark, source 2 a tall
    // monogram, and either must sit inside the same header band.
    const maxH = 38 * S, maxW = 165 * S;
    const sc = Math.min(maxH / logo.naturalHeight, maxW / logo.naturalWidth);
    const lw = logo.naturalWidth * sc, lh = logo.naturalHeight * sc;
    ctx.drawImage(logo, M, y, lw, lh);
    logoBottom = y + lh;
    logoRight = M + lw;
  } else {
    ctx.fillStyle = XPV_BRAND.dark;
    ctx.font = '700 ' + (26 * S) + 'px Georgia, serif';
    ctx.textBaseline = 'top';
    ctx.fillText('LUCCINI', M, y + 6 * S);
    logoBottom = y + 40 * S;
    logoRight = M + ctx.measureText('LUCCINI').width;
  }

  /* Title and client details sit UNDER the logo, flush left with it — the whole
     header reads as one left column instead of a block hugging the right edge.
     The title still shrinks to fit, now against the full content width, so a
     longer wording can never run off the page. */
  ctx.textBaseline = 'top';
  ctx.textAlign = 'left';
  ctx.fillStyle = XPV_BRAND.dark;
  const title = 'CUSTOM UNIFORM — QUOTE REQUEST';
  const titleSpace = W - 2 * M;
  let titleSize = 17;
  do {
    ctx.font = '700 ' + (titleSize * S) + 'px Arial, sans-serif';
    if (ctx.measureText(title).width <= titleSpace) break;
    titleSize -= 0.5;
  } while (titleSize > 9);
  let ly = logoBottom + 12 * S;
  ctx.fillText(title, M, ly);
  ly += (titleSize + 8) * S;

  ctx.font = (10 * S) + 'px Arial, sans-serif';
  ctx.fillStyle = XPV_BRAND.text;
  [
    ['Name', client.name],
    ['Organization', client.organization],
    ['Email', client.email],
    ['Phone', client.phone],
    ['Date', new Date().toLocaleDateString('en-US')]
  ].forEach(([k, v]) => {
    if (!v) return;
    ctx.fillText(k + ': ' + v, M, ly);
    ly += 14 * S;
  });

  y = ly + 14 * S;
  rule(y);
  y += 18 * S;

  /* ---- SWATCHES: the colour bubbles, wrapped over as many rows as needed ---- */
  if (swatches.length) {
    ctx.textAlign = 'left';
    ctx.fillStyle = XPV_BRAND.dark;
    ctx.font = '700 ' + (11 * S) + 'px Arial, sans-serif';
    ctx.fillText('SELECTED COLORS', M, y);
    y += 20 * S;

    /* Eight per row, and the row spans the full content width — a fixed 78pt
       cell only fitted six and left a whole cell of dead margin on the right,
       which is what made a many-colour order run over the page. The cell is
       derived from the count instead of the other way round, so the grid stays
       flush with the rules above and below it whatever the page width is. */
    const perRow = 8;
    const cell = (W - 2 * M) / perRow;
    const r = 13 * S, lineH = 8.5 * S, maxLines = 3;
    // Names now break over up to three lines in a narrower cell, so the gutter
    // only has to keep neighbouring labels apart, not fit a whole word.
    const labelWidth = cell - 6 * S;

    /* Wrap the colour name instead of cutting it. Luccini's names are long —
       "Barbe Columbia Blue", "GBG Columbia Blue", "Charcoal Heather Grey" — and
       a hard cut turned most of them into "Barbe Columbia Bl…", which is useless
       on a quote the customer reads. Only a single word wider than the cell is
       still hard-cut, since there is nowhere to break it. */
    ctx.font = (7 * S) + 'px Arial, sans-serif';
    const wrapLabel = (text) => {
      const words = String(text || '').trim().split(/\s+/);
      const lines = [];
      let line = '';
      words.forEach(w => {
        const next = line ? line + ' ' + w : w;
        if (ctx.measureText(next).width <= labelWidth || !line) line = next;
        else { lines.push(line); line = w; }
      });
      if (line) lines.push(line);
      if (lines.length > maxLines) {
        const kept = lines.slice(0, maxLines);
        let last = kept[maxLines - 1];
        while (last.length > 1 && ctx.measureText(last + '…').width > labelWidth) last = last.slice(0, -1);
        kept[maxLines - 1] = last + '…';
        return kept;
      }
      return lines.map(l => {
        if (ctx.measureText(l).width <= labelWidth) return l;
        let cut = l;                       // single word too wide to break
        while (cut.length > 1 && ctx.measureText(cut + '…').width > labelWidth) cut = cut.slice(0, -1);
        return cut + '…';
      });
    };

    const wrapped = swatches.map(sw => wrapLabel(sw.label));
    const usedLines = Math.max(1, ...wrapped.map(l => l.length));
    const rowH = 2 * r + 6 * S + usedLines * lineH + 8 * S;   // grows with the tallest label

    swatches.forEach((sw, i) => {
      const cx = M + (i % perRow) * cell + cell / 2;
      const cy = y + Math.floor(i / perRow) * rowH + r;
      ctx.beginPath();
      ctx.arc(cx, cy, r, 0, Math.PI * 2);
      ctx.fillStyle = sw.hex;
      ctx.fill();
      ctx.lineWidth = 1 * S;
      ctx.strokeStyle = '#c9c9c9';
      ctx.stroke();

      ctx.fillStyle = XPV_BRAND.text;
      ctx.font = (7 * S) + 'px Arial, sans-serif';
      ctx.textAlign = 'center';
      // labels are colour names (the catalogue carries no PMS codes)
      wrapped[i].forEach((line, n) => ctx.fillText(line, cx, cy + r + 6 * S + n * lineH));
      ctx.textAlign = 'left';
    });
    y += Math.ceil(swatches.length / perRow) * rowH + 6 * S;
    rule(y);
    y += 18 * S;
  }

  /* ---- PIPING: the option chosen, and the width it has to be cut at ----
     Production reads the width off this sheet; the print-ready artwork itself
     carries no such note (Expivi template, not ours). Three columns rather than
     a sentence so a row can be scanned without reading it. */
  if (piping && piping.length) {
    ctx.textAlign = 'left';
    ctx.textBaseline = 'top';
    ctx.fillStyle = XPV_BRAND.dark;
    ctx.font = '700 ' + (11 * S) + 'px Arial, sans-serif';
    ctx.fillText('PIPING', M, y);
    y += 19 * S;

    const colValue = M + 72 * S, colWidth = M + 196 * S;
    piping.forEach(p => {
      ctx.fillStyle = XPV_BRAND.text;
      ctx.font = '700 ' + (8.5 * S) + 'px Arial, sans-serif';
      ctx.fillText(p.zone, M, y);

      ctx.fillStyle = '#6b6b6b';
      ctx.font = (8.5 * S) + 'px Arial, sans-serif';
      ctx.fillText(p.value, colValue, y);

      // No width for "No neck piping" — an em dash says "asked and answered",
      // which a blank cell does not.
      ctx.fillStyle = p.width ? XPV_BRAND.text : '#9a9a9a';
      ctx.font = (p.width ? '700 ' : '') + (8.5 * S) + 'px Arial, sans-serif';
      ctx.fillText(p.width || '—', colWidth, y);
      y += 13 * S;
    });
    y += 8 * S;
    rule(y);
    y += 18 * S;
  }

  /* ---- CENTRE: the actual print-ready file(s) ----
     Each PRF is drawn on a light-grey panel, NOT straight onto the page. The
     renders are transparent PNGs whose artwork is the garment in its chosen
     colour — for a white uniform that is white-on-transparent, which is
     invisible on white paper (this is exactly why Expivi's own print-ready
     preview page looks like an empty sheet). The grey panel makes it readable
     whatever the colour. */
  // Load first, discard broken renders, THEN lay out — otherwise a skipped
  // render would leave an empty slot and off-centre the rest.
  const drawable = [];
  for (const p of (prfs || [])) {
    try {
      const img = await xpvLoadImage(p.url);
      if (xpvIsBrokenPrfRender(img)) {
        console.warn('⚠️ print-ready render #' + p.prfId + ' came back solid black — skipped. This is an Expivi template issue, report it to the config team.');
        continue;
      }
      drawable.push({ p, img });
    } catch (e) {
      console.warn('⚠️ PRF image could not be loaded:', p, e);
    }
  }

  /* The download links printed at the bottom of the page (see the block after
     this one) are laid out first because the render panels have to give up the
     height they occupy — otherwise a tall panel would run straight over them. */
  // The viewer page, NOT the raster we drew above: it is the link the internal
  // Luccini email already carries, and it is where the actual production file
  // is downloaded from. The PNG is offered separately, under its own render.
  const prfLinks = (prfs || []).filter(p => p && p.hash).map(p => ({
    label: p.label || ('Print ready file #' + p.prfId),
    url:   'https://expivi.net/print-ready-service?hash=' + p.hash
  }));
  const linkRowH = 22 * S;
  const linksH = prfLinks.length ? (18 * S + prfLinks.length * linkRowH + 10 * S) : 0;

  // Clickable areas, in page points (canvas / S), collected as the page is
  // drawn and turned into real PDF annotations once the canvas is flattened.
  const pdfLinkAreas = [];

  if (drawable.length) {
    ctx.fillStyle = XPV_BRAND.dark;
    ctx.font = '700 ' + (11 * S) + 'px Arial, sans-serif';
    ctx.textAlign = 'left';
    ctx.fillText('PRINT-READY FILE' + (drawable.length > 1 ? 'S' : ''), M, y);
    y += 20 * S;

    const availW = W - 2 * M;
    // 44pt below the panels: two caption lines (the garment name and the link
    // to the image) plus the footer note.
    const availH = H - y - M - 44 * S - linksH;
    const slotW = availW / drawable.length;
    const panelH = Math.min(availH, slotW);

    drawable.forEach(({ p, img }, i) => {
      const px = M + i * slotW, pw = slotW - (drawable.length > 1 ? 8 * S : 0);
      ctx.fillStyle = '#F4F4F4';
      ctx.fillRect(px, y, pw, panelH);
      ctx.strokeStyle = XPV_BRAND.line; ctx.lineWidth = 1 * S;
      ctx.strokeRect(px + 0.5 * S, y + 0.5 * S, pw - S, panelH - S);
      const sc = Math.min((pw - 12 * S) / img.naturalWidth, (panelH - 12 * S) / img.naturalHeight);
      const dw = img.naturalWidth * sc, dh = img.naturalHeight * sc;
      ctx.drawImage(img, px + (pw - dw) / 2, y + (panelH - dh) / 2, dw, dh);
      ctx.fillStyle = '#6b6b6b';
      ctx.font = (8 * S) + 'px Arial, sans-serif';
      ctx.textAlign = 'center';
      ctx.fillText(p.label || ('Print ready file #' + p.prfId), px + pw / 2, y + panelH + 4 * S);

      // The render is flattened into the page image, so it can only ever be
      // read at the size printed here. A link to the PNG itself, right under
      // it, is how you get to look at it full size.
      ctx.fillStyle = '#1a6fc4';
      ctx.font = (7.5 * S) + 'px Arial, sans-serif';
      const openTxt = 'Open image (PNG)';
      const openY = y + panelH + 16 * S;
      ctx.fillText(openTxt, px + pw / 2, openY);
      const tw = ctx.measureText(openTxt).width;
      pdfLinkAreas.push({
        x: (px + pw / 2 - tw / 2) / S,
        y: (openY - 2 * S) / S,
        w: tw / S,
        h: 11,
        url: p.url
      });
      ctx.textAlign = 'left';
    });
    y += panelH + 28 * S;
  }

  /* ---- BOTTOM: the print-ready file links ----
     These used to live only in the body of the internal Luccini email. The
     factory works from the file, so the link has to travel WITH the sheet:
     forward the PDF and everything needed to produce the order is in it.
     The list is built from `prfs`, the SAME filtered source the render panels
     use, so it inherits the "No pants" guard in xpvRelevantAttributes() for
     free: a pants-less order never requests prf 7327, so no pants picture and
     no pants link. Do not rebuild this list from the raw configuration.
     It does keep a prf whose render was skipped just above, though — the file
     itself is fine, it is Expivi's raster preview of it that comes back black,
     and dropping the link would cost the factory a file it did order. */
  if (prfLinks.length) {
    const bandTop = H - M - linksH;
    rule(bandTop - 8 * S);

    let ly = bandTop + 4 * S;
    ctx.textAlign = 'left';
    ctx.textBaseline = 'top';
    ctx.fillStyle = XPV_BRAND.dark;
    ctx.font = '700 ' + (11 * S) + 'px Arial, sans-serif';
    ctx.fillText('PRINT-READY FILE' + (prfLinks.length > 1 ? 'S' : '') + ' — DOWNLOAD', M, ly);
    ly += 18 * S;

    prfLinks.forEach(l => {
      const label = l.label + '   ';
      ctx.fillStyle = XPV_BRAND.text;
      ctx.font = '700 ' + (8.5 * S) + 'px Arial, sans-serif';
      ctx.fillText(label, M, ly);
      const lx = M + ctx.measureText(label).width;

      /* A file URL is long and its length varies with the hash, so shrink it
         until it fits the remaining width rather than letting it run off the
         page. Below 6.5pt it stops being readable — at that point it is
         truncated visually, and the clickable area below still carries the
         full URL. */
      const maxW = (W - M) - lx;
      let size = 8.5, shown = l.url;
      do {
        ctx.font = (size * S) + 'px Arial, sans-serif';
        if (ctx.measureText(shown).width <= maxW) break;
        size -= 0.5;
      } while (size > 6.5);
      while (ctx.measureText(shown).width > maxW && shown.length > 12) {
        shown = shown.slice(0, -2) + '…';
      }
      ctx.fillStyle = '#1a6fc4';
      ctx.fillText(shown, lx, ly);

      pdfLinkAreas.push({
        x: lx / S,
        y: (ly - 2 * S) / S,
        w: maxW / S,
        h: (size + 5),
        url: l.url
      });
      ly += linkRowH;
    });
  }

  /* ---- FOOTER ---- */
  ctx.fillStyle = '#8a8a8a';
  ctx.font = (8 * S) + 'px Arial, sans-serif';
  ctx.textAlign = 'center';
  ctx.fillText('Luccini — print-ready summary. Colors shown are the selected catalogue colors.', W / 2, H - M + 4 * S);

  const pdf = new jsPDF({ orientation: 'portrait', unit: 'pt', format: 'a4' });
  /* JPEG, at a quality high enough that its artefacts do not show on type.
     PNG would be the better codec for a page of text and line art, and it was
     tried — but jsPDF does not keep a PNG compressed. It expands it into a raw
     bitmap inside the document: measured here, a 0.19 MB PNG canvas became a
     30.6 MB PDF, and the quote POST that carries it grew to 42.8 MB and was
     dropped before it ever reached the webhook. A JPEG is embedded as-is, so
     the same page came out at 0.11 MB.

     Quality is 0.98 rather than the 0.92 this shipped with: at 0.92 the ringing
     around glyph edges was visible and read as blur. Together with the higher
     resolution above, that is what the sharpness fix rests on. If the text ever
     has to be perfect, the answer is to draw it as PDF text instead of pixels —
     not to change the codec. */
  pdf.addImage(cv.toDataURL('image/jpeg', 0.98), 'JPEG', 0, 0, 595, 842);
  // The page is one flattened image, so the URLs drawn above are just pixels.
  // Overlaying link annotations on the same coordinates makes them clickable in
  // any PDF reader without depending on the reader's URL auto-detection.
  pdfLinkAreas.forEach(a => { try { pdf.link(a.x, a.y, a.w, a.h, { url: a.url }); } catch (e) {} });
  return pdf.output('datauristring').split(',')[1];   // bare base64
}

/* Details of the last sheet we built — consumed by the preview panel below. */
let xpvLastSheet = null;

/* Orchestrator used by the quote submit. Never throws: on any problem it
   returns null and the email goes out without the attachment. */
async function xpvBuildQuoteSheet(configJson, client) {
  try {
    const swatches = xpvGetSwatches(configJson);
    const piping   = xpvGetPiping(configJson);
    let prfs = [];
    try {
      prfs = await xpvGetPrfPngUrls(configJson);
    } catch (e) {
      console.warn('⚠️ PRF render unavailable, building sheet without it:', e);
    }
    const b64 = await xpvBuildBrandedPdf({ swatches, piping, prfs, client });
    xpvLastSheet = { swatches, piping, prfs, b64 };
    console.log('📄 Branded quote sheet built:', swatches.length, 'swatches,',
      Math.round(b64.length / 1365), 'KB');
    return b64;
  } catch (e) {
    console.error('❌ Branded quote sheet failed, sending quote without it:', e);
    return null;
  }
}

/* ---------------------------------------------------------------------------
   PREVIEW MODE — add ?xpv_pdf_preview=1 to the configurator URL.
   Submitting the quote form then builds the sheet and shows it, and does NOT
   post anything to Make: no webhook call, no customer email, no internal
   email. This is how to QA the layout against a real configuration without
   touching the live scenario 7842427 or building a second one.
   The panel mirrors Expivi's own print-ready-service page: the document plus a
   "Files" list, so the generated PRF links can be opened and compared.
   ------------------------------------------------------------------------ */
function xpvPreviewMode() {
  try { return new URL(window.location.href).searchParams.get('xpv_pdf_preview') === '1'; }
  catch (e) { return false; }
}

function xpvShowSheetPreview(onSendAnyway) {
  const s = xpvLastSheet;
  const old = document.getElementById('xpv-sheet-preview');
  if (old) old.remove();

  let pdfUrl = '';
  if (s && s.b64) {
    const bytes = atob(s.b64);
    const arr = new Uint8Array(bytes.length);
    for (let i = 0; i < bytes.length; i++) arr[i] = bytes.charCodeAt(i);
    pdfUrl = URL.createObjectURL(new Blob([arr], { type: 'application/pdf' }));
  }

  const row = (label, href, note) =>
    '<li style="margin:8px 0"><b style="color:#00262B">' + label + '</b>' +
    (note ? ' <span style="color:#a33">' + note + '</span>' : '') +
    '<br><a href="' + href + '" target="_blank" rel="noopener" ' +
    'style="color:#1a6fc4;word-break:break-all;font-size:12px">' + href + '</a></li>';

  const files = [];
  if (pdfUrl) files.push(row('Our branded sheet (PDF)', pdfUrl, ''));
  // Both links the sheet now prints, so the preview can be checked against it.
  (s && s.prfs || []).forEach(p => {
    const name = p.label || ('Print ready file #' + p.prfId);
    if (p.hash) {
      files.push(row(name + ' (Expivi download page)',
        'https://expivi.net/print-ready-service?hash=' + p.hash, ''));
    }
    files.push(row(name + ' (PNG render)', p.url, ''));
  });

  const wrap = document.createElement('div');
  wrap.id = 'xpv-sheet-preview';
  wrap.style.cssText = 'position:fixed;inset:0;z-index:2147483647;background:#fafafa;' +
    'overflow:auto;font:14px Arial,sans-serif';
  wrap.innerHTML =
    '<div style="background:#00262B;color:#fff;padding:12px 20px;display:flex;' +
      'align-items:center;justify-content:space-between;gap:12px">' +
      '<b>Luccini — branded quote sheet (PREVIEW — nothing was sent)</b>' +
      '<span>' +
        '<button id="xpv-preview-send" style="background:#fff;border:0;color:#00262B;' +
          'font-weight:700;padding:8px 16px;cursor:pointer;border-radius:3px;margin-right:8px">' +
          'Send the quote anyway</button>' +
        '<button id="xpv-preview-close" style="background:#CBA052;border:0;color:#00262B;' +
          'font-weight:700;padding:8px 16px;cursor:pointer;border-radius:3px">Close</button>' +
      '</span>' +
    '</div>' +
    '<div style="display:flex;gap:20px;padding:20px;align-items:flex-start;flex-wrap:wrap">' +
      (pdfUrl
        ? '<embed src="' + pdfUrl + '" type="application/pdf" ' +
          'style="width:620px;height:860px;border:1px solid #ccc;background:#fff">'
        : '<div style="color:#a33">The sheet could not be built — check the console.</div>') +
      '<div style="flex:1;min-width:340px">' +
        '<h3 style="margin:0 0 4px;color:#00262B">Files</h3>' +
        '<ul style="padding-left:18px;margin:0">' + files.join('') + '</ul>' +
        '<p style="color:#666;font-size:12px;margin-top:16px">' +
          (s ? s.swatches.length + ' colour(s) detected.' : '') +
          ' A print-ready render that comes back solid black is skipped and logged' +
          ' in the console — that is an Expivi template issue, not a layout one.' +
        '</p>' +
      '</div>' +
    '</div>';
  document.body.appendChild(wrap);
  document.getElementById('xpv-preview-close').onclick = () => wrap.remove();
  document.getElementById('xpv-preview-send').onclick = () => {
    wrap.remove();
    if (typeof onSendAnyway === 'function') onSendAnyway();
  };
}

// Spinner animation CSS (injected)
const style = document.createElement('style');
style.innerHTML = `
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}`;
document.head.appendChild(style);

// Kick off modal init slightly delayed
setTimeout(initExpiviSaveModal, 500);



// expivi AR button tooltip (fixed position, caret, no mouse-follow)
document.addEventListener('DOMContentLoaded', function () {
  if (!window.expivi || !window.expivi._events?.onChange) return;

  window.expivi._events.onChange.subscribe(function (e) {
    if (e.name !== 'fully_loaded') return;

    const btn = document.querySelector('#xpv-toolbar-item-web-ar');
    if (!btn || btn.dataset.tooltipBound) return; // prevent double-binding
    btn.dataset.tooltipBound = '1';

    // Replace icon + add label (kept from your current code)
    btn.querySelector('svg')?.remove();
    btn.insertAdjacentHTML('afterbegin', `
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="none"
           stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M12.6 4L16 2l3.4 2M16 2v5m3.4 21L16 30l-3.4-2M16 30v-5M4 13V9l3.3-2M4 9l4.2 2.5M28 19v4l-3.3 2M28 23l-4.2-2.5M7.3 25L4 23v-4M4 23l4.2-2.5M24.7 7L28 9v4M28 9l-4.2 2.5M16 20v-4l3.4-2M16 16l-3.4-2"/>
      </svg>
      <span>AR</span>
    `);

    // Create tooltip element once
    const tip = document.createElement('div');
    tip.className = 'xpv-ar-tooltip xpv-ar-tooltip--fixed';
    tip.setAttribute('role', 'tooltip');
    tip.textContent = 'View in Augmented Reality';
    document.body.appendChild(tip);

    // Positioning (centered above the button, with offset for caret)
    const positionTooltip = () => {
      const rect = btn.getBoundingClientRect();
      const scrollX = window.pageXOffset || document.documentElement.scrollLeft;
      const scrollY = window.pageYOffset || document.documentElement.scrollTop;

      // First make it visible offscreen to measure width/height
      tip.style.visibility = 'hidden';
      tip.style.display = 'block';

      const tw = tip.offsetWidth;
      const th = tip.offsetHeight;
      const caret = 8; // keep in sync with CSS --caret-size

      const left = rect.left + scrollX + rect.width / 2 - tw / 2;
      const top  = rect.top  + scrollY - th - caret;

      tip.style.left = `${Math.max(8, left)}px`; // clamp a bit from viewport edges
      tip.style.top  = `${Math.max(8, top)}px`;

      tip.style.visibility = '';
    };

    // Show/hide handlers (hover + focus for accessibility)
    const show = () => {
      positionTooltip();
      tip.classList.add('is-visible');
      // Keep it anchored on resize/scroll (but not mousemove)
      window.addEventListener('scroll', positionTooltip, { passive: true });
      window.addEventListener('resize', positionTooltip);
    };
    const hide = () => {
      tip.classList.remove('is-visible');
      window.removeEventListener('scroll', positionTooltip);
      window.removeEventListener('resize', positionTooltip);
    };

    btn.addEventListener('mouseenter', show);
    btn.addEventListener('mouseleave', hide);
    btn.addEventListener('focusin', show);
    btn.addEventListener('focusout', hide);
  });

});


document.addEventListener('DOMContentLoaded', function () {

  window.expivi._events.onChange.subscribe(function (e) {
    if (e.name !== "fully_loaded") return;

    /* ---------------------------
      1) Camera buttons UI (mount OUTSIDE Expivi render tree)
    ---------------------------- */
    if (!document.querySelector('.xpv-camera-controls')) {
      const cameraContainer = document.createElement('div');
      cameraContainer.className = 'xpv-camera-controls';

      const cameraViews = [
        { label: 'Front', value: 'att-camera-front' },
        { label: 'Left',  value: 'att-camera-left' },
        { label: 'Back',  value: 'att-camera-back' },
        { label: 'Right', value: 'att-camera-right' }
      ];

      cameraViews.forEach(view => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'xpv-camera-btn';

        btn.innerHTML = `
          <span class="xpv-camera-icon">
            <img src="https://cdn.shopify.com/s/files/1/0558/1668/3728/t/38/assets/camera_icon.svg" alt="${view.label}">
          </span>
          <span class="xpv-camera-label">${view.label}</span>
        `;

        btn.addEventListener('click', () => {
          window.expivi.setProductAttributeByKey('att-camera', view.value);
        });

        cameraContainer.appendChild(btn);
      });

      const expiviViewer = document.getElementById('expivi-viewer-container');
      const stableParent = expiviViewer?.parentElement; // ✅ stable, not re-rendered by Expivi

      if (stableParent) {
        stableParent.appendChild(cameraContainer);
      } else if (expiviViewer) {
        // fallback: if no parent found, still mount to viewer
        expiviViewer.appendChild(cameraContainer);
      }
    }

    /* ---------------------------------------------------------------
      2) TRIM-AWARE text distribution (replaces the old base→2/3 sync)
      ---------------------------------------------------------------
      Each text group (number / name / logo) has 3 stacked SVG text
      layers: `-base`, `-2`, `-3`. The number of trim colours chosen for
      that group decides how many layers carry the text; the REST must be
      blanked ('') — otherwise a stale/default value bleeds into the
      print-ready file (the reported bug: "24" with a ghost "1" behind,
      because unused layers kept a default number).

      The old logic copied base→2/3 blindly (and the front number to all
      number groups), so the hidden layers always carried the number →
      duplicates in the PRF.

      Colour → layer (confirmed against the live SVG): `-input-3` = fill /
      base colour (ALWAYS carries the text), `-input-2` = trim colour 1,
      `-input-base` = trim colour 2. So we fill from `-3` DOWN:
        trim None → 3 only              (3=src, 2='',  base='')
        trim 1    → 3 + 2               (3=src, 2=src, base='')
        trim 2    → 3 + 2 + base        (3=src, 2=src, base=src)
        toggle OFF (Include/Add = No) → ALL blank

      TWO PRODUCT MODELS, auto-detected per product:
        • NEW (catalogue restructure, e.g. 2-Button): the customer types into a
          dedicated `*-input-placeholder` (a text_input, NOT a render layer),
          and the trim count is a `*-input-trimamount` question (values
          None/1/2). We READ the placeholder as the source and WRITE
          base/2/3 — blanking base can never clear the input.
        • OLD (V-Neck / Full Button, until migrated): no placeholder — the
          visible input IS `*-input-base`, and the trim count is the keyless
          "Select number of trim colours for …" question (matched by name).
      Same distribution either way; only the SOURCE + TRIM lookups differ.
      Numbers are per-group on the NEW model (each group has its own
      placeholder, so front / rear / pants can differ); on the OLD model
      there is a single player-number input, shared across the number groups.
    ---------------------------------------------------------------- */
    if (!window.__xpvTrimDistributionBound) {
      window.__xpvTrimDistributionBound = true;

      // group -> its trim-count question name + include/add toggle name (+ shared number flag)
      // Each group knows: its NEW-model trim key (`-input-trimamount`), its
      // OLD-model trim question name, its include/add toggle (keyless in both
      // models → matched by name), and whether it shares the player number.
      const XPV_GROUPS = [
        /* `toggleKey` matters more than it looks. The pant number grew its own
           per-position toggles, and they were given the SAME NAMES the jersey
           already used — there are now two "Include Front Number" and two
           "Include Rear Number" on this product, told apart only by the step
           they hang from. Resolving a toggle by name therefore returns whichever
           one happens to come first, which is how changing the jersey number
           blanked the pants: the pant groups asked "is my toggle on?", read the
           jersey's answer, got No, and wiped their layers. Keys are unambiguous;
           the names are kept only as a fallback for a catalogue without them. */
        { g: 'front-number',       toggleKey: 'front-number-toggle',       trimKey: 'front-number-input-trimamount', trimName: 'Select number of trim colors for front number', toggle: 'Include Front Number',      number: true },
        { g: 'back-number',        toggleKey: 'back-number-toggle',        trimKey: 'back-number-input-trimamount',  trimName: 'Select number of trim colors for back number',  toggle: 'Include Rear Number',       number: true },
        /* The two pant positions used to share ONE trim control, so the back
           followed the front and its own setting did nothing. The catalogue has
           since split them — "…for front of pant" (the original attribute, key
           unchanged) and "…for back of pant" (new, keyed 2026-08-20) — which
           makes the pants structurally the same as the jersey. Each position
           reads its own trim now.
           The front key is still `pants-number-…` rather than
           `pants-front-number-…`: renaming it would break the live theme until
           the new JS is uploaded, and buys nothing but symmetry. */
        { g: 'pants-front-number', toggleKey: 'pants-front-number-toggle', trimKey: 'pants-number-input-trimamount',      trimName: 'Select number of trim colors for front of pant', toggle: 'Include Front Number', number: true },
        { g: 'pants-back-number',  toggleKey: 'pants-back-number-toggle',  trimKey: 'pants-back-number-input-trimamount', trimName: 'Select number of trim colors for back of pant',  toggle: 'Include Rear Number',  number: true },
        { g: 'player-name',        trimKey: 'player-name-input-trimamount',  trimName: 'Select number of trim colors for player name',  toggle: 'Add player name to back',   number: false },
        { g: 'team-logo',          trimKey: 'team-logo-input-trimamount',    trimName: 'Select number of trim colors for team name',    toggle: null,                        number: false }
      ];

      const groupByPlaceholder = {};    // '<group>-input-placeholder' -> cfg   (NEW-model source)
      const groupByBase        = {};    // '<group>-input-base'        -> cfg   (OLD-model source)
      const groupByTrimKey     = {};    // '<group>-input-trimamount'  -> [cfg] (NEW-model trim; pants shared)
      XPV_GROUPS.forEach(c => {
        groupByPlaceholder[c.g + '-input-placeholder'] = c;
        groupByBase[c.g + '-input-base'] = c;
        (groupByTrimKey[c.trimKey] = groupByTrimKey[c.trimKey] || []).push(c);
      });

      const idByName = {};              // attribute_name -> id  (toggles + old-model trim, by name)
      const idByKey  = {};              // attribute_key  -> id  (new-model placeholder/trim, by key)
      const sourceText = {};            // group -> current typed text (held in JS)
      const sourceFont = {};            // group -> current font
      const catalogueDefault = {};      // number group -> the number it ships with ("24")
      const userTyped = {};             // group -> when the customer last typed in its own box
      let writing = false;              // guard: ignore onChange fired by our own writes

      async function resolveMeta() {
        if (Object.keys(idByKey).length || Object.keys(idByName).length) return;
        const attrs = await window.expivi.getProductAttributes();
        attrs.forEach(a => {
          const n = a.attribute_name || a.name;
          if (n && idByName[n] === undefined) idByName[n] = a.id;
          if (a.key) idByKey[a.key] = a.id;
        });
        /* Record what number each position ships with, read here because this
           runs before we have written anything. Switching a position on makes
           the viewer copy that value into the customer-facing input, and we have
           to be able to tell that copy apart from something they typed. */
        XPV_GROUPS.filter(c => c.number).forEach(c => {
          const layer = attrs.find(a => a.key === c.g + '-input-3');
          catalogueDefault[c.g] = layer ? valueText(layer) : '';
        });
      }
      // a group is on the NEW model when it has a dedicated placeholder input
      const groupUsesNewModel = (g) => idByKey[g + '-input-placeholder'] !== undefined;
      /* Read the text carried by an attribute / onChange payload.
         Shapes differ per attribute type and are NOT interchangeable:
           • question  -> attribute_value_name ("None" / "1" / "2")
           • text_input-> attribute_value_name is "" ; the typed text lives in
                          attribute_value.text
           • svg_text  -> same, attribute_value.text
         Reading only attribute_value_name (what this code used to do) yields ""
         for every text input, which made us blank all three render layers. */
      /* A text_to_image attribute encodes its state into attribute_value_name as
         "23 @size:1.00; @font:Swingman;" while attribute_value.text / .value hold
         the clean "23". Reading the name first printed those directives onto the
         garment, so the STRUCTURED fields are tried first and the name is only a
         last resort — which is still what questions (trim None/1/2, Yes/No
         toggles) need, since their attribute_value carries no text at all.
         Directives are stripped anyway, in case another attribute type embeds
         them somewhere we do end up reading. */
      const stripDirectives = (s) => String(s || '').replace(/\s*@[a-z_]+\s*:[^;]*;/gi, '').trim();
      function valueText(a) {
        if (!a) return '';
        const v = a.attribute_value || a.selected_value_value;
        if (v && typeof v.text === 'string' && v.text !== '') return stripDirectives(v.text);
        if (v && typeof v.value === 'string' && v.value !== '') return stripDirectives(v.value);
        if (a.attribute_value_name) return stripDirectives(a.attribute_value_name);
        return '';
      }

      /* Current NAME of a question's selected option.
         getAttributeById() returns the attribute WITHOUT attribute_value_name and
         WITHOUT attribute_value — only selected_value_id plus the full
         attribute_values list. So resolve the option ourselves. The legacy fields
         are still tried first in case an older viewer build supplies them. */
      async function questionValue(id) {
        if (!id) return null;
        try {
          const a = await window.expivi.getAttributeById(id);
          if (!a) return null;
          const legacy = a.attribute_value_name || (a.attribute_value && a.attribute_value.name);
          if (legacy) return legacy;
          const selId = a.selected_value_id != null
            ? a.selected_value_id
            : (a.selected_value_value && a.selected_value_value.attribute_value_id);
          if (selId == null || !Array.isArray(a.attribute_values)) return null;
          const opt = a.attribute_values.find(v => v.id === selId);
          return opt ? (opt.name || opt.key || null) : null;
        } catch (e) { return null; }
      }

      /* Current text of an attribute, by key (used to seed sourceText). */
      async function currentTextByKey(key) {
        try {
          const attrs = await window.expivi.getProductAttributes();
          const a = attrs.find(x => x.key === key);
          return valueText(a);
        } catch (e) { return ''; }
      }
      // current trim option NAME (None/1/2) for a group — NEW model reads the
      // `-input-trimamount` question by key, OLD model the named question.
      async function trimValue(cfg) {
        const id = groupUsesNewModel(cfg.g) ? idByKey[cfg.trimKey] : idByName[cfg.trimName];
        return questionValue(id);
      }
      // how many of the 3 layers carry the text for a given trim option
      function layersForTrim(trimName) {
        const v = (trimName || '').trim();
        if (v === '1') return 2;
        if (v === '2') return 3;
        return 1; // "None" / default
      }
      // The font is applied even to layers we are blanking. Gating it on `text`
      // left the trim layers on whatever font they had last — the catalogue rule
      // is that whichever font is selected for a group also applies to its three
      // layers — so raising the trim afterwards briefly showed the outline in the
      // OLD font.
      async function setLayer(key, text, font) {
        const opt = { text: text };
        if (font) opt.font = font;
        await window.expivi.setProductAttributeByKey(key, opt);
      }
      const isOff = (v) => /^(no|off)$/i.test((v || '').trim());

      /* A player wears one number, so entering it once should be enough — the
         catalogue restructure gave each position its own `-input-placeholder`,
         which left the four inputs unconnected and let a position fall back to
         the "24" baked into its own render layer.

         It is a one-way fill, not a merge. The FRONT number is the input the
         customer is asked for ("Enter Player Number"; the others still carry
         internal names) and it fills the positions they have not set. Editing
         the back or a pant number changes only that position and hands it to
         the customer for good: front and back are separate garment locations
         with separate toggles, so pushing a rear number back onto the front
         would be inventing a choice they did not make.

         Name and logo are per-group and never take part. */
      const MASTER_NUMBER_GROUP = 'front-number';
      const numberGroups = () => XPV_GROUPS.filter(c => c.number);
      const ownNumber = {};   // group -> the customer typed into it directly

      /* What the master number holds, if anything. Checked before a group falls
         back to its own render layer, whose value is a CATALOGUE DEFAULT ("24"
         on every number group of the V-Neck) — seeding from that is what
         printed a number the customer never chose. */
      async function masterNumberText(group) {
        if (group === MASTER_NUMBER_GROUP) return '';
        if (sourceText[MASTER_NUMBER_GROUP]) return sourceText[MASTER_NUMBER_GROUP];
        if (!groupUsesNewModel(MASTER_NUMBER_GROUP)) return '';
        return await currentTextByKey(MASTER_NUMBER_GROUP + '-input-placeholder');
      }

      /* Push the shared number into the OTHER groups' visible inputs, so the
         field the customer reads agrees with what the garment renders. Skipped
         when the value is already there: the placeholder is a text_to_image,
         so every write costs a render round-trip.

         The payload is NOT the one the render layers take, and it must match
         what the customer's own typing produces, field for field. A layer is an
         svg_text and reads `text`; the placeholder is the text_to_image bound to
         the on-screen box, and that box renders `value` — writing only `text`
         set the attribute while the field stayed blank at 0/32.

         Writing BOTH was worse. Typing into the box updates `value` alone, so
         our `text` stayed behind as a stale copy: editing a mirrored back number
         from 7 to 77 arrived as `{value:"77", text:"7"}`, the reader preferred
         `text`, concluded nothing had changed, and left the garment on 7 while
         the field showed 77. Only `value` is written now, exactly as the UI
         does. The font already on the attribute survives the write. */
      const mirroredNumber = {};
      /* Mirroring writes to inputs that are themselves sources, so the change
         event for a mirror can land after `writing` has been cleared. The cache
         above already stops a write loop; this stops the redundant re-runs, which
         would otherwise multiply one keystroke into four full distributions. */
      let propagatingNumber = false;
      async function mirrorNumberInput(group, text) {
        if (!groupUsesNewModel(group)) return;   // old model has no separate input
        if (mirroredNumber[group] === text) return;
        mirroredNumber[group] = text;
        writing = true;
        try {
          await window.expivi.setProductAttributeByKey(group + '-input-placeholder', { value: text });
        } finally { writing = false; }
      }

      async function distribute(cfg, override) {
        await resolveMeta();
        override = override || {};
        // Use the value straight from the onChange event when available — re-reading
        // via getAttributeById right after a change can return the STALE (pre-change)
        // value, so a trim/toggle change would redistribute with the old value.
        const trimName = override.trimName !== undefined
          ? override.trimName
          : await trimValue(cfg);
        let enabled;
        if (override.enabled !== undefined) enabled = override.enabled;
        else if (cfg.toggleKey || cfg.toggle) {
          // Key first: the names are duplicated across jersey and pant, so a
          // name lookup can answer for the wrong garment (see XPV_GROUPS).
          const tid = (cfg.toggleKey && idByKey[cfg.toggleKey]) || idByName[cfg.toggle];
          enabled = !isOff(await questionValue(tid));
        }
        else enabled = true;
        /* Seed the source once from the live configuration.
           sourceText is only ever filled by onChange, so until the customer types
           we hold nothing — while a DESIGN TEMPLATE may already have preset the
           layers (e.g. "V-Neck Uniform" ships the team name "Luccini" on all
           three layers while leaving the placeholder empty). Distributing with an
           unseeded source wiped that text the moment the customer touched a trim
           dropdown. Prefer the placeholder (the customer-facing input); fall back
           to layer -3, which always carries the text. */
        if (sourceText[cfg.g] === undefined) {
          let seed = '';
          if (groupUsesNewModel(cfg.g)) seed = await currentTextByKey(cfg.g + '-input-placeholder');
          /* Numbers only: for a position the customer has not set themselves,
             the master number outranks both this position's layer and its input
             — the viewer may already have copied the catalogue number into that
             input as the position was switched on, and an empty input and one
             holding "24" mean the same thing here: nothing was chosen for this
             position. Without this, switching a number on for the first time
             rendered "24" over the number they had already entered. The input is
             filled to match, or they see a blank field under a rendered number.
             A position they have edited never reaches this branch — its source
             is already set. Name / logo keep the old order, where the layer is
             the only place a design template's preset text lives. */
          if (cfg.number && !ownNumber[cfg.g] &&
              (!seed || seed === catalogueDefault[cfg.g])) {
            const master = await masterNumberText(cfg.g);
            if (master) { seed = master; await mirrorNumberInput(cfg.g, seed); }
          }
          if (!seed) seed = await currentTextByKey(cfg.g + '-input-3');
          sourceText[cfg.g] = seed;
        }
        const src  = sourceText[cfg.g] || '';
        const font = sourceFont[cfg.g];
        const n = enabled ? layersForTrim(trimName) : 0;
        // Fill from layer 3 (`-3`) DOWN to base. Confirmed via the colour→layer map:
        // the fill / "base color" sits on SVG FrontNumber_Trim02 = `-3`, trim color 1
        // on FrontNumber_Trim01 = `-2`, trim color 2 on FrontNumber_Base = `-base`.
        // So a plain number (trim None) renders on `-3` only; +1 trim adds `-2`;
        // +2 trims adds `-base`. Filling base-first left the number invisible at low
        // trim (base carries the 2nd trim colour, not the fill).
        writing = true;
        try {
          await setLayer(cfg.g + '-input-3',    n >= 1 ? src : '', font);
          await setLayer(cfg.g + '-input-2',    n >= 2 ? src : '', font);
          await setLayer(cfg.g + '-input-base', n >= 3 ? src : '', font);
        } finally { writing = false; }
      }

      window.expivi._events.onChange.subscribe(async (event) => {
        if (event.name !== 'attribute' || writing) return;
        await resolveMeta();

        const a    = event.payload;
        const key  = a && a.attribute_key;
        const name = a && a.attribute_name;
        const text = valueText(a);   // NOT attribute_value_name — see valueText()
        const font = a && a.attribute_value && a.attribute_value.font;

        // (A) SOURCE changed. NEW model: the customer types into `-input-placeholder`
        //     (a real text input, separate from the render layers). OLD model: the
        //     visible input IS `-input-base`. `-base` is only a source on the OLD model —
        //     on the NEW model it is a layer WE write to, so it must be ignored here.
        let srcCfg = null;
        if (key && groupByPlaceholder[key]) srcCfg = groupByPlaceholder[key];
        else if (key && groupByBase[key] && !groupUsesNewModel(groupByBase[key].g)) srcCfg = groupByBase[key];
        if (srcCfg) {
          const previousSource = sourceText[srcCfg.g];
          sourceText[srcCfg.g] = text || '';
          if (font) sourceFont[srcCfg.g] = font;
          /* The viewer writes these inputs by itself: flipping any one number
             toggle fires a change on ALL FOUR number inputs carrying an empty
             value, and switching a position on copies that position's catalogue
             number into its box, so "24" arrives looking chosen. Read as
             customer input, the first wiped a propagated number and the second
             printed one nobody picked — and both claimed the position as the
             customer's own, which is why a number entered in front stopped
             reaching the back.

             Neither the value nor its timing can separate those writes from
             typing: the blanks are empty, the copy equals the catalogue number
             a customer might legitimately enter, and both land around the same
             toggle change in an order that is not guaranteed — which is exactly
             what made a time window unreliable. The DOM can: a real edit raises
             an `input` event on the box itself, and the viewer's writes do not.
             So a change is only taken as the customer's if they were just
             typing into that position's own box. */
          const typedItJustNow = (g) => Date.now() - (userTyped[g] || 0) < 4000;

          if (srcCfg.number && !typedItJustNow(srcCfg.g)) {
            if (srcCfg.g === MASTER_NUMBER_GROUP) {
              // hold what we had rather than let a stray blank clear the front
              sourceText[srcCfg.g] = previousSource !== undefined ? previousSource : (text || '');
              await distribute(srcCfg);
              return;
            }
            /* Their own number for this position, else the one they entered up
               front. With neither, keep what arrived: that is the catalogue's
               own number, and an untouched configurator should still look the
               way the catalogue ships it. */
            const keep = ownNumber[srcCfg.g]
              ? (previousSource || '')
              : ((await masterNumberText(srcCfg.g)) || text || '');
            sourceText[srcCfg.g] = keep;
            if (keep !== text) {
              delete mirroredNumber[srcCfg.g];   // the viewer changed the input behind us
              await mirrorNumberInput(srcCfg.g, keep);
            }
            await distribute(srcCfg);
            return;
          }

          /* The master number fills the positions the customer has not set; any
             other number input changes only itself. Editing the back number used
             to overwrite the front as well, which is not a correction the
             customer asked for — the two are separate locations with separate
             toggles. From then on that position is theirs, so a later change to
             the front number leaves it alone instead of silently undoing it. */
          if (srcCfg.number && srcCfg.g !== MASTER_NUMBER_GROUP) {
            ownNumber[srcCfg.g] = true;
            mirroredNumber[srcCfg.g] = text || '';   // its own input already holds it
            await distribute(srcCfg);
            return;
          }
          if (srcCfg.number) {
            if (propagatingNumber) { sourceText[srcCfg.g] = text || ''; return; }
            propagatingNumber = true;
            try {
              const followers = numberGroups().filter(c => c.g !== srcCfg.g && !ownNumber[c.g]);
              mirroredNumber[srcCfg.g] = text || '';   // its own input already holds it
              followers.forEach(c => { sourceText[c.g] = text || ''; if (font) sourceFont[c.g] = font; });
              for (const c of followers) await mirrorNumberInput(c.g, text || '');
              await distribute(srcCfg);
              for (const c of followers) await distribute(c);
            } finally { propagatingNumber = false; }
          } else {
            await distribute(srcCfg);
          }
          return;
        }

        /* (B) a trim-count question or an include/add toggle changed → redistribute
              the affected group(s) with the FRESH value from the event, never a
              stale re-read.
              Matching is by KEY wherever the catalogue provides one. The toggle
              names are duplicated across jersey and pant, so a name match here
              would fire BOTH garments' groups off a single toggle — the jersey's
              switch would redistribute the pants and vice versa. The name is
              still accepted, but only for groups that have no key. */
        const affected = XPV_GROUPS.filter(c =>
          (key && c.toggleKey === key) ||
          (!c.toggleKey && c.toggle === name) ||
          c.trimName === name ||
          (key && c.trimKey === key));
        for (const c of affected) {
          const override = {};
          if (c.trimName === name || (key && c.trimKey === key)) override.trimName = text;
          // Same rule as the filter above: the key decides when there is one.
          if ((key && c.toggleKey === key) || (!c.toggleKey && c.toggle === name)) {
            override.enabled = !isOff(text);   // fresh Include/Add value
          }
          await distribute(c, override);
        }
      });

      /* The one signal that separates the customer's typing from the viewer's
         own writes to the same inputs. Bound on the document because the options
         panel is re-rendered on every attribute change, and each box sits under
         a wrapper carrying the attribute key, which is what maps it to a group. */
      document.addEventListener('input', function (e) {
        const holder = e.target && e.target.closest && e.target.closest('[data-xpv-key]');
        if (!holder) return;
        const k = holder.getAttribute('data-xpv-key') || '';
        const cfg = groupByPlaceholder[k] || groupByBase[k];
        if (cfg) userTyped[cfg.g] = Date.now();
      }, true);
    }


  });

});


// ===============================================================
//  CHOOSE JERSEY switcher (P2)
//  The 3 jerseys (V-Neck / Full Button / 2 Button) are separate
//  Expivi products. This injects a "Choose jersey" dropdown at the
//  top of the options panel; picking another jersey navigates to
//  that product's configurator through the SAME Shopify app-proxy
//  (/apps/configurator?catalogue=<id>), so expivi-custom.js
//  (Request Quote + filter + Make) keeps running on every jersey.
//  Derbystar-style navigation between separate products — NOT an
//  in-product model swap. Switching reloads, so the current design
//  resets (expected when changing jersey style). The active jersey
//  is detected from the ?catalogue= URL param and shown selected.
//
//  NOTE: anchored in .configurator-container (OUTSIDE the Vue app
//  #app-xpv-*), so an Expivi re-render never wipes it.
// ===============================================================
(function () {
  var JERSEYS = [
    { id: '9226920755444', label: 'V-Neck' },
    { id: '9398537683188', label: 'Full Button' },
    { id: '9163306139892', label: '2 Button' }
  ];

  function currentCatalogue() {
    try { return new URL(window.location.href).searchParams.get('catalogue'); }
    catch (e) { return null; }
  }

  function isJerseyPage(cat) {
    return !!cat && JERSEYS.some(function (j) { return j.id === cat; });
  }

  function gotoJersey(id) {
    if (!id || id === currentCatalogue()) return;
    var u = new URL(window.location.href);
    u.searchParams.set('catalogue', id);       // keep any other params (pb=0, etc.)
    window.location.href = u.pathname + '?' + u.searchParams.toString();
  }

  // Custom dropdown (button + styled menu), NOT a native <select>: a <select>
  // can only style the closed control — the OPEN option list is drawn by the OS
  // and looks foreign. This mirrors the native Expivi dropdown for both states.
  var CARET = "<svg class='xpv-jersey-switch__caret' viewBox='0 0 24 24' fill='none' aria-hidden='true'>" +
              "<path d='M7 10l5 5 5-5' stroke='#020202' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/></svg>";

  function buildSelector(current) {
    var curLabel = 'Select';
    JERSEYS.forEach(function (j) { if (j.id === current) curLabel = j.label; });

    var wrap = document.createElement('div');
    wrap.className = 'xpv-jersey-switch';
    wrap.innerHTML =
      "<span class='xpv-jersey-switch__label'>Choose jersey</span>" +
      "<div class='xpv-jersey-switch__dropdown'>" +
        "<div class='xpv-jersey-switch__field' role='button' tabindex='0' aria-haspopup='listbox' aria-expanded='false'>" +
          "<span class='xpv-jersey-switch__value'></span>" + CARET +
        "</div>" +
        "<ul class='xpv-jersey-switch__menu' role='listbox' hidden></ul>" +
      "</div>";

    // Fill text nodes safely (avoid injecting labels as HTML)
    wrap.querySelector('.xpv-jersey-switch__value').textContent = curLabel;
    var menu = wrap.querySelector('.xpv-jersey-switch__menu');
    JERSEYS.forEach(function (j) {
      var li = document.createElement('li');
      li.className = 'xpv-jersey-switch__item' + (j.id === current ? ' is-active' : '');
      li.setAttribute('role', 'option');
      li.setAttribute('data-id', j.id);
      li.textContent = j.label;
      menu.appendChild(li);
    });

    var dd    = wrap.querySelector('.xpv-jersey-switch__dropdown');
    var field = wrap.querySelector('.xpv-jersey-switch__field');

    function open()  { dd.classList.add('is-open');  menu.hidden = false; field.setAttribute('aria-expanded', 'true'); }
    function close() { dd.classList.remove('is-open'); menu.hidden = true;  field.setAttribute('aria-expanded', 'false'); }

    field.addEventListener('click', function (e) { e.stopPropagation(); if (menu.hidden) { open(); } else { close(); } });
    field.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); if (menu.hidden) { open(); } else { close(); } }
      else if (e.key === 'Escape') { close(); }
    });
    menu.addEventListener('click', function (e) {
      var it = e.target.closest('.xpv-jersey-switch__item');
      if (!it) return;
      var id = it.getAttribute('data-id');
      if (id !== current) { gotoJersey(id); } else { close(); }
    });
    document.addEventListener('click', function (e) { if (!wrap.contains(e.target)) close(); });

    return wrap;
  }

  function inject() {
    if (document.querySelector('.xpv-jersey-switch')) return;   // idempotent
    var current = currentCatalogue();
    if (!isJerseyPage(current)) return;                         // only on the 3 jerseys
    var container = document.querySelector('.configurator-container');
    if (!container) { setTimeout(inject, 300); return; }        // wait for Expivi shell
    container.insertBefore(buildSelector(current), container.firstChild);
  }

  document.addEventListener('DOMContentLoaded', inject);
})();


// ===============================================================
//  PRESERVE SCROLL POSITION on option change (V-Neck / Full Button
//  / 2 Button feedback: "still having to scroll up when selecting
//  tab options"). Expivi re-renders the options panel on every
//  attribute change, which resets .configurator-container.scrollTop
//  to 0, so the user is thrown back to the top of the panel.
//
//  Fix: remember the user's scroll position and restore it right
//  after the re-render. We track scrollTop on user scroll, and when
//  an 'attribute' change fires we re-apply the saved position over a
//  few animation frames (~700ms) to catch whenever the render lands.
//  A `restoring` flag stops the render's scroll:0 from being saved
//  as the user's position (which would defeat the restore).
// ===============================================================
(function () {
  function init() {
    if (!(window.expivi && window.expivi._events && window.expivi._events.onChange)) {
      return setTimeout(init, 300);
    }
    var container = document.querySelector('.configurator-container');
    if (!container) return setTimeout(init, 300);

    var savedTop = 0;
    var restoring = false;

    container.addEventListener('scroll', function () {
      if (restoring) return;          // ignore the render's reset-to-0
      savedTop = container.scrollTop; // track the user's real position
    }, { passive: true });

    function restoreLoop() {
      restoring = true;
      var frames = 0;
      var maxFrames = 42; // ~700ms at 60fps
      (function step() {
        // clamp to current content height (panel may be shorter after change)
        var max = Math.max(0, container.scrollHeight - container.clientHeight);
        var target = Math.min(savedTop, max);
        if (container.scrollTop < target - 4) {
          // the re-render reset us upward → restore
          container.scrollTop = target;
        } else if (container.scrollTop > savedTop + 4) {
          // the user actively scrolled during the window → follow, don't fight
          savedTop = container.scrollTop;
        }
        frames++;
        if (frames < maxFrames) {
          requestAnimationFrame(step);
        } else {
          setTimeout(function () { restoring = false; }, 0);
        }
      })();
    }

    window.expivi._events.onChange.subscribe(function (e) {
      // Fire on option/attribute changes (the ones that re-render the panel).
      if (e && e.name === 'attribute') {
        restoreLoop();
      }
    });

    /* ---------------------------------------------------------------
       KEEP THE CLICKED SECTION UNDER THE CURSOR (feedback: "when I
       click select number or select player it scrolls down to further
       selection fields and I need to come back to those").

       The panels are an accordion, so opening one closes the one above
       it. That removes its content — measured at ~700px for Numbers —
       from ABOVE the header just clicked, and the panel keeps its
       scrollTop, so everything slides up under a fixed viewport: the
       header the customer aimed at ends up off-screen and the fields
       now in view belong further down the list.

       Restoring scrollTop, which is what the handler above does for a
       re-render, is the wrong move here — the number is the very thing
       that stops meaning the same place once content above it is gone.
       The header itself is the anchor instead: its distance from the
       top of the viewport is measured before the accordion moves and
       held there while the expand/collapse animates.

       WHICH element scrolls is not fixed, so the correction is spread
       over the whole ancestor chain instead of assuming one node.
       `.configurator-container` scrolls when the list is taller than the
       viewport; on a tall window it fits and `.expivi-page-container`
       scrolls instead, with only ~56px of travel; when nothing is left
       the page itself scrolls. Anchoring against the container alone did
       nothing in those layouts, and anchoring against a single nearest
       scroller stopped short once that one hit its end — so each
       ancestor absorbs what it can and passes the remainder up.

       The listener sits on the document because the options panel is
       re-rendered on every attribute change, and a listener bound to a
       node inside it dies with that node.
    ---------------------------------------------------------------- */
    function anchorBy(el, delta) {
      var node = el.parentElement;
      var remaining = delta;
      while (node && node !== document.body && Math.abs(remaining) > 0.5) {
        var oy = getComputedStyle(node).overflowY;
        if ((oy === 'auto' || oy === 'scroll' || oy === 'overlay') &&
            node.scrollHeight > node.clientHeight + 1) {
          var max  = Math.max(0, node.scrollHeight - node.clientHeight);
          var from = node.scrollTop;
          node.scrollTop = Math.max(0, Math.min(max, from + remaining));
          remaining -= (node.scrollTop - from);
          // Keep the restore handler's idea of "where the user was" in step with
          // the anchor, so an attribute change landing in the same window cannot
          // pull the panel back to a position this click just made obsolete.
          if (node === container) savedTop = container.scrollTop;
        }
        node = node.parentElement;
      }
      if (Math.abs(remaining) > 0.5) window.scrollBy(0, remaining);
    }

    document.addEventListener('click', function (e) {
      var header = e.target && e.target.closest && e.target.closest('.v-expansion-panel-header');
      if (!header) return;
      // Capture phase: this runs before the accordion toggles, so the
      // measurement is the position the customer is actually looking at.
      var before = header.getBoundingClientRect().top;
      var frames = 0;
      var maxFrames = 30;   // ~500ms, longer than the expansion transition
      (function step() {
        // A re-render can replace the header node mid-flight. A detached node
        // reports a rect of all zeros, which reads as a huge upward jump and
        // would send the panel somewhere the customer never asked to go, so the
        // anchor is abandoned rather than chased.
        if (!document.contains(header)) return;
        var delta = header.getBoundingClientRect().top - before;
        if (Math.abs(delta) > 1) anchorBy(header, delta);
        frames++;
        if (frames < maxFrames) requestAnimationFrame(step);
      })();
    }, true);
  }
  document.addEventListener('DOMContentLoaded', init);
})();
